import isEqual from 'lodash/isEqual'
import { blendRGBAOverRGB, hexToRgb, rgbToHex } from '@/services/utils/color'

export const getColorsFromTheme = (theme) => {
  const { id, is_default, lid, match_theme, name, ...colors } = theme ?? {}

  return colors
}

export const formColorsToDTO = (form) => {
  return {
    text_color: form.main?.textColor ?? null,
    main_color: form.main?.mainColor ?? null,
    background_color: form.main?.bgColor ?? null,
    active_color: form.filter?.activeColor ?? null,
    fill: form.main?.fill ?? null,
    overlay_color: form.main?.overlayColor ?? null,
    icon_color: form.main?.iconColor ?? null,
    content_on_active_color: form.filter?.contentColor ?? null,
    banner_background_color: form.headerButton?.bgColor ?? null,
    banner_text_color: form.headerButton?.textColor ?? null,
    schema: form.schema ?? null,
    overlay_schema: form.headerButton.overlaySchema ?? null,
  }
}

export const DTOToFormColors = (dtoTheme) => {
  const theme = dtoTheme ?? {}
  return {
    schema: theme.schema ?? 'light',
    filter: {
      activeColor: theme.active_color ?? '#000000',
      contentColor: theme.content_on_active_color ?? '#000000',
    },
    headerButton: {
      overlaySchema: theme.overlay_schema ?? 'light',
      textColor: theme.banner_text_color ?? '#000000',
      bgColor: theme.banner_background_color ?? '#000000',
    },
    main: {
      mainColor: theme.main_color ?? '#000000',
      fill: theme.fill ?? '#000000',
      bgColor: theme.background_color ?? '#000000',
      overlayColor: theme.overlay_color ?? '#000000',
      textColor: theme.text_color ?? '#000000',
      iconColor: theme.icon_color ?? '#000000',
    },
  }
}

export const formWidgetToDTO = (block, lid) => {
  return {
    type: 'banner',
    langs: [
      {
        lid,
        title: block.name,
        link: block.linkType === 'sport' ? block.sportId : block.link,
        info_link: block.showInfo ? block.infoLink : null,
        background_image_id: block.backgroundImageId,
        link_type: block.linkType,
        show_info_icon: block.showInfo,
      },
    ],
  }
}

export const formEventToDTO = (match, lid) => {
  return {
    type: 'event',
    langs: [
      {
        lid,
        championship_id: match.championshipId,
        match_id: match.id,
        sport_id: match.sportId,
        match_name: match.name,
      },
    ],
  }
}

export const formChampToDTO = (champ, lid) => {
  return {
    type: 'champ',
    langs: [
      {
        lid,
        championship_id: champ.championshipId,
      },
    ],
  }
}

export const isFormColorsMatchTheme = (form, selectedTheme) => {
  const normalizedFormColors = formColorsToDTO(form)
  const normalizedThemeColors = getColorsFromTheme(selectedTheme)

  if (!isEqual(normalizedFormColors, normalizedThemeColors)) {
    return false
  }

  return true
}

const createBlendedGradient = (baseColor, stops) => {
  const base = hexToRgb(baseColor)

  const blendedStops = stops.map((stop) =>
    rgbToHex(blendRGBAOverRGB(base, stop)),
  )

  return `linear-gradient(270deg, ${blendedStops[0]} 0%, ${blendedStops[1]} 100%)`
}

export const blendedGradientDark = (baseColor) =>
  createBlendedGradient(baseColor, [
    { r: 0, g: 0, b: 0, a: 0.3 },
    { r: 0, g: 0, b: 0, a: 0.03 },
  ])

export const blendedGradientLight = (baseColor) =>
  createBlendedGradient(baseColor, [
    { r: 255, g: 255, b: 255, a: 0.05 },
    { r: 255, g: 255, b: 255, a: 0.6 },
  ])

export const gradientBackground = (baseColor, schema) =>
  schema === 'light'
    ? blendedGradientLight(baseColor)
    : blendedGradientDark(baseColor)

export const mixWithBase = (baseColor, schema) => {
  const base = hexToRgb(baseColor)

  const overlay =
    schema === 'light'
      ? { r: 255, g: 255, b: 255, a: 0.4 } // white @ 40%
      : { r: 0, g: 0, b: 0, a: 0.3 } // black @ 30%

  const blended = blendRGBAOverRGB(base, overlay)

  return rgbToHex(blended)
}
